'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UIConfirmModal from 'UIComponents/dialog/UIConfirmModal';
import { deleteModule as deleteModuleAction, deleteModuleFromLayoutSection as deleteModuleFromLayoutSectionAction, deleteColumnFromLayoutSection as deleteColumnFromLayoutSectionAction, deleteRowFromLayoutSection as deleteRowFromLayoutSectionAction, closeDeleteRequestModal as closeDeleteRequestModalAction } from 'ContentEditorUI/redux/actions/moduleActions';
import { getIsLayoutSectionDeleteRequested, getModuleIdToDelete, getLayoutSectionModuleIdToDelete, getLayoutSectionColumnIdToDelete, getLayoutSectionRowIdToDelete, getLayoutSectionIdForDeleteRequest } from 'ContentEditorUI/redux/selectors/deleteRequestSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
const mapStateToProps = state => ({
  isDeleteRequested: getIsLayoutSectionDeleteRequested(state),
  moduleIdToDelete: getModuleIdToDelete(state),
  layoutSectionModuleIdToDelete: getLayoutSectionModuleIdToDelete(state),
  columnIdToDelete: getLayoutSectionColumnIdToDelete(state),
  rowIdToDelete: getLayoutSectionRowIdToDelete(state),
  layoutSectionId: getLayoutSectionIdForDeleteRequest(state)
});
const mapDispatchToProps = {
  deleteModule: deleteModuleAction,
  deleteModuleFromLayoutSection: deleteModuleFromLayoutSectionAction,
  deleteRowFromLayoutSection: deleteRowFromLayoutSectionAction,
  deleteColumnFromLayoutSection: deleteColumnFromLayoutSectionAction,
  closeDeleteRequestModal: closeDeleteRequestModalAction
};
class DeleteRequestModalContainer extends Component {
  constructor(props) {
    super(props);
    this.handleCancelDelete = this.handleCancelDelete.bind(this);
    this.handleConfirmDelete = this.handleConfirmDelete.bind(this);
  }
  handleCancelDelete() {
    const {
      closeDeleteRequestModal
    } = this.props;
    closeDeleteRequestModal();
  }
  handleConfirmDelete() {
    const {
      moduleIdToDelete,
      layoutSectionModuleIdToDelete,
      columnIdToDelete,
      rowIdToDelete,
      layoutSectionId,
      deleteModule,
      deleteModuleFromLayoutSection,
      deleteRowFromLayoutSection,
      deleteColumnFromLayoutSection
    } = this.props;
    if (moduleIdToDelete) {
      // Deleting from a flex column
      deleteModule(moduleIdToDelete);
      const bus = window.hubspot.ContentEditorUI.eventBus;
      bus.trigger('saveAndTriggerRefresh');
    } else if (layoutSectionModuleIdToDelete) {
      deleteModuleFromLayoutSection(layoutSectionModuleIdToDelete, layoutSectionId);
    } else if (columnIdToDelete) {
      deleteColumnFromLayoutSection(columnIdToDelete, layoutSectionId);
    } else if (rowIdToDelete) {
      deleteRowFromLayoutSection(rowIdToDelete, layoutSectionId);
    }
  }
  render() {
    const {
      isDeleteRequested,
      moduleIdToDelete,
      layoutSectionModuleIdToDelete,
      columnIdToDelete,
      rowIdToDelete
    } = this.props;
    if (!isDeleteRequested) {
      return null;
    }
    let messageKey;
    let descriptionKey;
    if (moduleIdToDelete || layoutSectionModuleIdToDelete) {
      messageKey = 'app.deleteDialogTitle';
      descriptionKey = 'app.deleteDialogBody';
    } else if (columnIdToDelete) {
      messageKey = 'app.layoutSection.deleteColumnDialogTitle';
      descriptionKey = 'app.layoutSection.deleteColumnDialogBody';
    } else if (rowIdToDelete) {
      messageKey = 'app.layoutSection.deleteRowDialogTitle';
      descriptionKey = 'app.layoutSection.deleteRowDialogBody';
    }
    return /*#__PURE__*/_jsx(UIConfirmModal, {
      onConfirm: this.handleConfirmDelete,
      onReject: this.handleCancelDelete,
      description: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: descriptionKey
      }),
      message: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: messageKey
      })
    });
  }
}
DeleteRequestModalContainer.propTypes = {
  isDeleteRequested: PropTypes.bool.isRequired,
  moduleIdToDelete: PropTypes.string,
  layoutSectionModuleIdToDelete: PropTypes.string,
  columnIdToDelete: PropTypes.string,
  rowIdToDelete: PropTypes.string,
  layoutSectionId: PropTypes.string,
  deleteModule: PropTypes.func.isRequired,
  deleteModuleFromLayoutSection: PropTypes.func.isRequired,
  deleteRowFromLayoutSection: PropTypes.func.isRequired,
  deleteColumnFromLayoutSection: PropTypes.func.isRequired,
  closeDeleteRequestModal: PropTypes.func.isRequired
};
export default connect(mapStateToProps, mapDispatchToProps)(DeleteRequestModalContainer);